/**
 * Create coupon tokens context for custom hook
 */
import { createContext } from 'react'

const CouponTokensContext = createContext({
  createCouponToken: () => {},
  createCouponTokenTransfer: () => {},
  createCouponTokenByTokenTransfer: () => {},
  createCouponTokenShare: () => {},
  fetchCouponToken: () => {},
  fetchCouponTokenByQrCode: () => {},
  fetchCouponTokenByToken: () => {},
  fetchCouponTokens: () => {},
  fetchCouponTokensAll: () => {},
  fetchCouponTokenTransferTransactions: () => {}
});

export default CouponTokensContext
